<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
                  <v-select
                    v-model="month"
                    :items="monthNameTH"
                    dense
                    outlined
                    hide-details
                     clearable
                  clear-icon="mdi-close-circle"
                    label="เดือนที่สร้างข้อมูล"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="year"
                    :items="yearsNumber"
                    dense
                    outlined
                    hide-details
                    label="ปีที่สร้างข้อมูล"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="leaveType"
                    :items="itemsLeaveTypeSelect"
                    dense
                    outlined
                    hide-details
                    label="ประเภทลา"
                     clearable
                  clear-icon="mdi-close-circle"
                    class="ma-2"
                  ></v-select>
                  <v-btn
                    class="mt-2"
                    elevation="2"
                    color="info"
                    text
                    @click="getData()"
                  >
                    <v-icon left>mdi-calendar-search</v-icon>
                    ค้นหา
                  </v-btn>
            </v-sheet>
          </v-col>
           </v-row>
          <v-row>
            <v-col cols="6">
              <v-btn
                :loading="!dataReady"
                :disabled="!dataReady"
                color="blue-grey"
                class=" white--text"
                @click="exportLeave()"
              >
                Download
                <v-icon right dark> mdi-cloud-download </v-icon>
              </v-btn>
              <v-btn
                :loading="!dataReady"
                :disabled="!dataReady"
                color="blue-grey"
                class=" white--text"
                @click="getData()"
              >
                reload
                <v-icon right dark> mdi-reload </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-text-field
              v-model="searchAll"
              dense
              outlined
              append-icon="mdi-magnify"
              label="ค้นหา รายชื่อ"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- data table -->
        <v-row>

          <v-col cols="12">
            <v-alert dense type="info" icon="mdi-account-switch">
              รายการ <strong>ขออนุมัติลา</strong>
            </v-alert>
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-data-table
                  :headers="columnsItem"
                  :items="dataItem"
                  :search="searchAll"
                  :items-per-page="10"
                >
                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                <template v-slot:[`item.leaveEmergency`]="{ item }">
                    <v-btn
                      color="warning"
                      fab
                      small
                      dark
                      v-if="item.leaveEmergency == 'True'"
                    >
                      <v-icon>mdi-alert</v-icon>
                    </v-btn>
                  </template>
                 <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                       color="red"
                      class="ma-2"
                      dark
                      @click="getDataById(item), dialog=true"
                    >
                    <v-icon>mdi-alert</v-icon> จัดการ
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>

          <v-col cols="12">
            <v-alert dense type="success" icon="mdi-account-switch">
              รายการ <strong>อนุมัติลา</strong>
            </v-alert>
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-data-table
                  :headers="columnsItem"
                  :items="dataItemApprove"
                  :search="searchAll"
                  :items-per-page="10"
                >
                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                <template v-slot:[`item.leaveEmergency`]="{ item }">
                      <v-btn
              color="warning"
              fab
              small
              dark
               v-if="item.leaveEmergency == 'True'"
            >
              <v-icon>mdi-alert</v-icon>
            </v-btn>
                  </template>
                 <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="info"
                      @click="getDataById(item), dialogDetail=true"
                    >
                      ตรวจสอบ
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>

          <v-col cols="12">
            <v-alert dense type="error" icon="mdi-account-switch">
              รายการ <strong>ไม่อนุมัติลา</strong>
            </v-alert>
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-data-table
                  :headers="columnsItem"
                  :items="dataItemUnApprove"
                  :search="searchAll"
                  :items-per-page="10"
                >
                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date_1(item.CREATE_DATE) }}
                  </template>
                <template v-slot:[`item.leaveEmergency`]="{ item }">
                    <v-btn
                    color="warning"
                    fab
                    small
                    dark
                    v-if="item.leaveEmergency == 'True'"
                  >
                    <v-icon>mdi-alert</v-icon>
                  </v-btn>
                  </template>
                 <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="info"
                      @click="getDataById(item), dialogDetail=true"
                    >
                      ตรวจสอบ
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>

          <!-- end data table -->

        </v-row>

        <!-- รายละเอียด -->
        <v-dialog v-model="dialog" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล </span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>

                          <tr>
                            <td>หัวหน้า</td>
                            <td>{{ dateItemInfo.empFull_NameTH_approve }}</td>
                          </tr>
                          <!-- <tr>
                            <td>กะพนักงานส่งคำร้อง</td>
                            <td>
                              <v-chip class="ma-2" color="yellow" label>
                                ({{ dateItemInfo.shiftTransferOldShiftCode }})
                                {{ dateItemInfo.OldDate }}
                              </v-chip>
                            </td>
                          </tr> -->
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการลา</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>ประเภทลา</td>
                            <td>{{ dateItemInfo.quotaLeaveName }}</td>
                          </tr>
                          <tr>
                            <td>ตั้งแต่วันที่ - ถึงวันที่</td>
                            <td>{{ dateItemInfo.leaveStartDate }} - {{ dateItemInfo.leaveEndDate }}</td>
                          </tr>
                          <tr>
                            <td>จำนวนวันลา</td>
                            <td>{{ dateItemInfo.leaveSummaryDay }}</td>
                          </tr>
                          <tr>
                            <td>เบอร์ติดต่อ</td>
                            <td>{{ dateItemInfo.leavePhoneEmergency }}</td>
                          </tr>
                          <tr>
                            <td>รายละเอียด</td>
                            <td>{{ dateItemInfo.leaveDetail }}</td>
                          </tr>
                          <tr>
                            <td>สถานะ</td>
                            <td>{{ dateItemInfo.leaveStatus }}</td>
                          </tr>
                           <tr>
                            <td>ไฟล์แนบ 1</td>
                            <td> <a :href="dateItemInfo.leaveFile"  target="_blank" download v-if="dateItemInfo.leaveFile">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                           <tr>
                            <td>ไฟล์แนบ 2</td>
                            <td> <a :href="dateItemInfo.leaveFile2"  target="_blank" download v-if="dateItemInfo.leaveFile2">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>

              </v-card>

            </v-card-text>
            <v-card-text>
              <v-card>
                <v-textarea
                    v-model="leaveRemark"
                        maxlength="100"
                        rows="3"
                        row-height="25"
                        outlined
                        :rules="nameRules"
                        clearable
                        clear-icon="mdi-close-circle"
                        label="หมายเหตุ"
                ></v-textarea>
              </v-card>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialog = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="success"
                text
                @click="dialog = false, approve(dateItemInfo, 'approve',leaveRemark)"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="red"
                text
                @click="dialog = false,approve(dateItemInfo, 'unapprove',leaveRemark)"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่อนุมัติ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- รายละเอียด -->
        <v-dialog v-model="dialogDetail" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>  <span class="headline">ตรวจสอบข้อมูล </span> |
               <v-btn
                depressed
                color="warning"
                v-if="dateItemInfo.leaveEmergency === 'True'"
              >
                  <v-icon>mdi-alert</v-icon> ลาด่วน
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                          <tr>
                            <td>หัวหน้า</td>
                            <td>{{ dateItemInfo.empFull_NameTH_approve }}</td>
                          </tr>
                          <!-- <tr>
                            <td>กะพนักงานส่งคำร้อง</td>
                            <td>
                              <v-chip class="ma-2" color="yellow" label>
                                ({{ dateItemInfo.shiftTransferOldShiftCode }})
                                {{ dateItemInfo.OldDate }}
                              </v-chip>
                            </td>
                          </tr> -->
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการลา</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                         <tr>
                            <td>ประเภทลา</td>
                            <td>{{ dateItemInfo.quotaLeaveName }}</td>
                          </tr>
                          <tr>
                            <td>ตั้งแต่วันที่ - ถึงวันที่</td>
                            <td>{{ dateItemInfo.leaveStartDate }} - {{ dateItemInfo.leaveEndDate }}</td>
                          </tr>
                          <tr>
                            <td>จำนวนวันลา</td>
                            <td>{{ dateItemInfo.leaveSummaryDay }}</td>
                          </tr>
                          <tr>
                            <td>เบอร์ติดต่อ</td>
                            <td>{{ dateItemInfo.leavePhoneEmergency }}</td>
                          </tr>
                          <tr>
                            <td>รายละเอียด</td>
                            <td>{{ dateItemInfo.leaveDetail }}</td>
                          </tr>
                          <tr>
                            <td>สถานะ</td>
                            <td>{{ dateItemInfo.leaveStatus }}</td>
                          </tr>
                           <tr>
                            <td>ไฟล์แนบ</td>
                            <td> <a :href="dateItemInfo.leaveFile"  target="_blank" download v-if="dateItemInfo.leaveFile">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>ไฟล์แนบ 2</td>
                            <td> <a :href="dateItemInfo.leaveFile2"  target="_blank" download v-if="dateItemInfo.leaveFile2">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>หมายเหตุ</td>
                            <td>{{dateItemInfo.leaveRemark}}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-text>
              <v-card>
                <v-textarea
                    v-if="(dateItemInfo.leaveStatus == 'approve')"
                    v-model="leaveRemark"

                        maxlength="100"
                        rows="3"
                        row-height="25"
                        outlined
                        :rules="nameRules"
                        clearable
                        clear-icon="mdi-close-circle"
                        label="หมายเหตุ"
                ></v-textarea>
              </v-card>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogDetail = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>
               <v-btn
                v-if="(dateItemInfo.leaveStatus == 'approve')"
                elevation="2"
                x-large
                color="red"
                text
                @click="dialog = false,approve(dateItemInfo, 'cancel',leaveRemark)"
              >
                <v-icon left> mdi-cancel</v-icon>
                ยกเลิกใบลา
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { gmapApi } from 'vue2-google-maps'
import moment from 'moment'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    gmapApi
  },
  // created () {
  //   setInterval(this.getNowGlobal, 1000)
  // },
  data () {
    return {
      path: '/leave_data/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายการคำร้องอนุมัติลา',
          disabled: false,
          href: '/HRM/Leave/LeaveRequest'
        }
      ],
      session: this.$session.getAll(),
      loading: false,
      loading2: false,
      dataReady: true,
      dialog: false,
      dialogDetail: false,
      columnsItem: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ประเภท', value: 'quotaLeaveName' },
        { text: 'ตั้งแต่', value: 'leaveStartDate' },
        { text: 'ถึง', value: 'leaveEndDate' },
        { text: 'จำนวน', value: 'leaveSummaryDay' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'หัวหน้า', value: 'empFull_NameTH_approve' },
        { text: 'ลาด่วน', value: 'leaveEmergency' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        {
          text: 'ตรวจสอบ',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      dataItem: [],
      itemsLeaveTypeSelect: [],
      leaveType: '',
      leaveStatus: '',
      leaveStartYear: '',
      itemsLeave: [],
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      dataItemApprove: [],
      dataItemUnApprove: [],
      dateItemInfo: [],
      year: '',
      month: '',
      day: '',
      leaveRemark: '-',
      nameRules: [(v) => !!v || 'Input is required']
    }
  },
  async mounted () {
    console.log(moment().format('YYYY'))
    this.year = moment().format('YYYY')
    await this.getData()

    this.month = this.getMonthTh()
    // let date = new Date()
    await this.getDataLeaveType()
  },
  methods: {
    async getData () {
      await this.getDataWaiting()
      await this.getDataApprove()
      await this.getDataUnApprove()
    },
    async getDataWaiting () {
      this.dataItem = []

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''
      console.log('leaveTypeSerch', leaveTypeSerch)

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'get?leaveStatus=waiting&empCodeApprove=' +
            this.$session.getAll().data.empCode + '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataApprove () {
      this.dataItemApprove = []

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'get?leaveStatus=approve&empCodeApprove=' +
            this.$session.getAll().data.empCode + '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemApprove = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataUnApprove () {
      this.dataItemUnApprove = []

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.month = (this.month) ? this.month : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'get?leaveStatus=unapprove&empCodeApprove=' +
            this.$session.getAll().data.empCode + '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemUnApprove = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataById (item) {
      this.dateItemInfo = []
      this.dateItemInfo = item
      // await axios
      //   .get(
      //     // eslint-disable-next-line quotes
      //     this.DNS_IP + this.path + 'getID?leaveId=' + item.leaveId,
      //     {
      //       headers: {
      //         'Application-Key': this.$session.getAll().ApplicationKey
      //       }
      //     }
      //   )
      //   .then(async (response) => {
      //     console.log(response)
      //     this.dataReady = true
      //     this.dateItemInfo = response.data
      //   })
      //   // eslint-disable-next-line handle-callback-err
      //   .catch((error) => {
      //     console.log(error)
      //     this.dataReady = true
      //   })
    },
    async getDataLeaveType () {
      console.log('getDataLeaveType', this.$session.getAll().data.positionTypeCode)
      // Clear Data ทุกครั้ง
      this.itemsLeaveTypeSelect = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_quota/' +
            'position_lavel_get?positionTypeCode=' +
            this.$session.getAll().data.positionTypeCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            let rs = response.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.quotaLeaveName
              s.value = d.quotaLeaveCode
              d = s
              this.itemsLeaveTypeSelect.push(d)
            }
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async approve (item, status, leaveRemark) {
      console.log('item', item)
      console.log('status', status)
      this.$swal({
        title: 'ท่านต้องการ ' + status + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dialog = false
          this.dialogDetail = false
          let ds = {
            leaveStatus: status,
            leaveRemark: leaveRemark,
            LAST_USER: this.$session.getAll().data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/leave_data/editLine/" + item.leaveId,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              await this.setUpBeforeSendLineApproveUnapprove(item, status)
              await this.getData()
              this.dataReady = true
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)
          this.$refs.inputFile.value = null

          this.dataReady = true
        })
    },
    async setUpBeforeSendLineApproveUnapprove (item, status) {
      var statusmessage = 'อนุมัติ'
      var color = '017305'
      if (status === 'unapprove') {
        statusmessage = 'ไม่อนุมัติ'
        color = '800305'
      }
      if (status === 'cancel') {
        statusmessage = 'ยกเลิก'
        color = '800305'
      }
      var payload = [
        {
          type: 'flex',
          altText: item.empFull_NameTH + '[' + statusmessage + item.quotaLeaveName + ']',
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: item.leaveImgUrl,
                  size: '60%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text:
                        'คำขออนุมัติ ' + item.quotaLeaveName,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: statusmessage,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: item.empFull_NameTH,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        'เริ่มวันที่ ' +
                        item.leaveStartDate +
                        ' ถึง' +
                        item.leaveEndDate,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'จำนวนวันลา ' + item.leaveSummaryDay + ' วัน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'วันที่ทำรายการ ' + moment().format('YYYY-MM-DD HH:mm:ss'),
                      wrap: true,
                      align: 'center'
                    }
                  ],
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      await this.setlineUser(item, payload)
      this.dataReady = false
    },
    async setlineUser (item, payload) {
      if (item.userLineuserId) {
        await this.sendLinePush(payload, item.userLineuserId)
      }
      if (item.userLineuserIdHeader) {
        await this.sendLinePush(payload, item.userLineuserIdHeader)
      }
      // if (item.userLineuserIdHeaderCC) {
      //   await this.sendLinePush(payload, item.userLineuserIdHeaderCC)
      // }
      // if (item.userLineuserId) {
      //   // U97a2b1814542579b9e5d7c1b891538ab
      //   await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      // }
      // if (item.userLineuserIdHeader) {
      //   await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      // }
      // if (item.userLineuserIdHeaderCC) {
      //   await this.sendLinePush(payload, 'U97a2b1814542579b9e5d7c1b891538ab')
      // }
    },
    async sendLinePush (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/push_message",
          dt, {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          // console.log(response)
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log('linenotify: ', error)
        })
    },
    async exportLeave () {
      var dataItme = []
      var dataApprove = []
      var dataUnapprove = []
      this.dataItem.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ประเภทลา': element.quotaLeaveName,
          'เริ่มวัน': element.leaveStartDay,
          'เริ่มเดือน': element.leaveStartMonth,
          'เริ่มปี': element.leaveStartYear,
          'วัน/เดือน/ปี': element.leaveStartDate,
          'สิ้นสุดวัน': element.leaveEndDay,
          'สิ้นสุดเดือน': element.leaveEndMonth,
          'บริสิ้นสุดปี': element.leaveEndYear,
          'สิ้นสุดวันเดือนปี': element.leaveEndDate,
          'จำนวนวันลา': element.leaveSummaryDay,
          'หัวหน้า': element.empFull_NameTH_approve,
          'เบอร์ติดต่อ': element.leavePhoneEmergency,
          'รายละเอียด': element.leaveDetail,
          'สถานะการลา': element.leaveStatus,
          'ไฟล์ที่แนบ1': element.leaveFile,
          'ไฟล์ที่แนบ2': element.leaveFile2,
          'วันที่สร้างข้อมูล': element.CREATE_DATE,
          'วันที่แก้ไขข้อมูล': element.LAST_DATE,
          'ผู้แก้ไข': element.LAST_USER
        }
        dataItme.push(s)
      })
      this.dataItemApprove.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ประเภทลา': element.quotaLeaveName,
          'เริ่มวัน': element.leaveStartDay,
          'เริ่มเดือน': element.leaveStartMonth,
          'เริ่มปี': element.leaveStartYear,
          'วัน/เดือน/ปี': element.leaveStartDate,
          'สิ้นสุดวัน': element.leaveEndDay,
          'สิ้นสุดเดือน': element.leaveEndMonth,
          'บริสิ้นสุดปี': element.leaveEndYear,
          'สิ้นสุดวันเดือนปี': element.leaveEndDate,
          'จำนวนวันลา': element.leaveSummaryDay,
          'หัวหน้า': element.empFull_NameTH_approve,
          'เบอร์ติดต่อ': element.leavePhoneEmergency,
          'รายละเอียด': element.leaveDetail,
          'สถานะการลา': element.leaveStatus,
          'ไฟล์ที่แนบ1': element.leaveFile,
          'ไฟล์ที่แนบ2': element.leaveFile2,
          'วันที่สร้างข้อมูล': element.CREATE_DATE,
          'วันที่แก้ไขข้อมูล': element.LAST_DATE,
          'ผู้แก้ไข': element.LAST_USER
        }
        dataApprove.push(s)
      })
      this.dataItemUnApprove.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ประเภทลา': element.quotaLeaveName,
          'เริ่มวัน': element.leaveStartDay,
          'เริ่มเดือน': element.leaveStartMonth,
          'เริ่มปี': element.leaveStartYear,
          'วัน/เดือน/ปี': element.leaveStartDate,
          'สิ้นสุดวัน': element.leaveEndDay,
          'สิ้นสุดเดือน': element.leaveEndMonth,
          'บริสิ้นสุดปี': element.leaveEndYear,
          'สิ้นสุดวันเดือนปี': element.leaveEndDate,
          'จำนวนวันลา': element.leaveSummaryDay,
          'หัวหน้า': element.empFull_NameTH_approve,
          'เบอร์ติดต่อ': element.leavePhoneEmergency,
          'รายละเอียด': element.leaveDetail,
          'สถานะการลา': element.leaveStatus,
          'ไฟล์ที่แนบ1': element.leaveFile,
          'ไฟล์ที่แนบ2': element.leaveFile2,
          'วันที่สร้างข้อมูล': element.CREATE_DATE,
          'วันที่แก้ไขข้อมูล': element.LAST_DATE,
          'ผู้แก้ไข': element.LAST_USER
        }
        dataUnapprove.push(s)
      })
      var data = XLSX.utils.json_to_sheet(dataItme)
      var unapprove = XLSX.utils.json_to_sheet(dataUnapprove)
      var approve = XLSX.utils.json_to_sheet(dataApprove)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, data, 'รายการคำขอ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, approve, 'รายการอนุมัติ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, unapprove, 'รายการไม่อนุมัติ') // sheetAName is name of Worksheet
      this.month = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      XLSX.writeFile(
        wb,
        'ลา(' + this.day + ' ' + this.month + ' ' + this.year + ').xls'
      ) // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
:root {
  --table-head-text: #ffffff;
  --table-body-row-even: #b1c9ea;
  --table-body-row-odd: #ffffff;
}
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Leave/LeaveRequest.vue